import { urls } from "../../urls";
import { CREATES_PROCUREMENT_PARAM, CREATES_PROCUREMENT_VALUE } from "./createProcurementParams";

export const isFullAssistantPage = (pathname: string, search: string): boolean =>
  pathname === urls.app.assistant &&
  new URLSearchParams(search).get(CREATES_PROCUREMENT_PARAM) !== CREATES_PROCUREMENT_VALUE;

export const createsProcurementWithAi = ({ pathname, search }: { pathname: string; search: string }): boolean =>
  pathname === urls.app.assistant &&
  new URLSearchParams(search).get(CREATES_PROCUREMENT_PARAM) === CREATES_PROCUREMENT_VALUE;
